/**
 * @generated SignedSource<<dfb14b4007ea8c1d35096c76d06223a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchResultListSectionSearchConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly __typename: "SectionSearchResultItem";
    };
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"sectionSearchResultListSectionSearchConnection">;
  readonly " $fragmentType": "searchResultListSectionSearchConnection";
};
export type searchResultListSectionSearchConnection$key = {
  readonly " $data"?: searchResultListSectionSearchConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultListSectionSearchConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "searchResultListSectionSearchConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSearchEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SectionSearchResultItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "sectionSearchResultListSectionSearchConnection"
    }
  ],
  "type": "SectionSearchConnection",
  "abstractKey": null
};

(node as any).hash = "fd8f6d6ab71cd50e0fcdbf5a37b81b41";

export default node;
